import React, { useMemo, useState } from "react";
import { authConfig } from "../auth/cognitoAuth";
import ProtectedSwagger from "../components/ProtectedSwagger";
import { createCognitoTokenOpenApi } from "../config/cognitoTokenOpenApi";
import { services } from "../config/services";
import { useI18n } from "../i18n/I18nContext";

const service = services.find((item) => item.route === "/token");
const clientId = authConfig.clientId || "<auth-client-id>";

const DicioBackTokenAPIDoc = () => {
    const { language, t } = useI18n();
    const [copied, setCopied] = useState(false);
    const spec = useMemo(() => createCognitoTokenOpenApi(language), [language]);

    const copyClientId = async () => {
        await navigator.clipboard.writeText(clientId);
        setCopied(true);
        window.setTimeout(() => setCopied(false), 1800);
    };

    return (
        <ProtectedSwagger
            attachBearerToken={false}
            authLabel="Auth"
            authStatusLabel={t("services.token.tokenBadge")}
            extraActions={
                <button
                    className="client-id-copy"
                    title={clientId}
                    type="button"
                    onClick={copyClientId}
                >
                    <span>Client ID</span>
                    <code>{clientId}</code>
                    <strong>{copied ? t("auth.copied") : t("auth.copy")}</strong>
                </button>
            }
            service={service}
            spec={spec}
        />
    );
};

export default DicioBackTokenAPIDoc;
